import FullWidthHeader from "@components/BasicComponents/FullWidthHeader/FullWidthHeader"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Description from "@components/CustomTypography/Description/Description"
import Separator from "@components/CustomTypography/Separator/Separator"
import getValueOrThrow from "@helpers/getValueOrError"
import {AdvancedSideAssetModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"

import styles from "./WhistleblowingChannelSection.module.scss"

type Props = {
	data: AdvancedSideAssetModuleType
}

const WhistleblowingChannelSection = (props: Props) => {
	const mainContent = getValueOrThrow(props.data.mainContent)
	return (
		<>
			<div id={"top"} />
			<FullWidthHeader
				data={{
					title: props.data.sectionTitle,
				}}
				position={"left"}
				size={"L"}
			/>
			<ContainerWrapper>
				<Separator size={128}>
					<div className={`${styles.tables}`}>
						<Description content={mainContent[0].content} />
					</div>
				</Separator>
			</ContainerWrapper>
		</>
	)
}

export default WhistleblowingChannelSection
